var optional = require("./optional");

var express = optional("express");
var fs = optional("fs");

console.log("express: " + express);
console.log("fs: " + fs);



//////////////////
// WEBPACK FOOTER
// ./~/optional/test.js
// module id = 1608
// module chunks = 0